module.exports = __webpack_public_path__ + "img/el-out25.eab6fe58.png";